import React from 'react'
import {  OverlayTrigger } from "react-bootstrap";

export function renderOptionsFieldSingle(field)
{

    return (
        <label  className="radio-inline c-radio">
       {field.popover && <OverlayTrigger trigger='click' placement='right' overlay={field.popover} rootClose  style={{ minWidth:'350px' }}>
            <input  {...field.input} type="radio"  value={field.optionvalue}  name={field.id}  checked={field.optionvalue === field.defaultvalue} />
       </OverlayTrigger> }  
       {!field.popover &&
            <input  {...field.input}  type="radio"  value={field.optionvalue}  name={field.id}  checked={field.optionvalue === field.defaultvalue}  />
       } 
            <em className="fa fa-circle" />&nbsp;&nbsp;{field.label}
        </label> 
    )
}




// WEBPACK FOOTER //
// ./src/modules/components/fieldoptioncomponentsingle.js